import React, { useState, useEffect, useRef } from 'react';
import { Box, useTheme, useMediaQuery } from '@mui/material';
import Header from '../Header/Header';
import Sidebar from '../Sidebar/Sidebar';
import ContentArea from '../ContentArea/ContentArea';
import { mainLayoutStyles } from './MainLayout.styles';
import { useLocation } from 'react-router-dom';

const MainLayout = ({ children }) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));
  const location = useLocation();
  const contentWrapperRef = useRef(null);

  const handleMobileMenuToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleMobileMenuClose = () => {
    setMobileOpen(false);
  };

  useEffect(() => {
    if (contentWrapperRef.current) {
      contentWrapperRef.current.scrollTop = 0;
    }
  }, [location.pathname]);

  return (
    <Box sx={mainLayoutStyles.container}>
      <Header onMobileMenuToggle={handleMobileMenuToggle} />
      <Box sx={mainLayoutStyles.mainContent}>
        <Sidebar
          mobileOpen={mobileOpen}
          onMobileClose={handleMobileMenuClose}
          isMobile={isMobile}
        />
        <Box component="main" sx={mainLayoutStyles.contentWrapper} ref={contentWrapperRef}>
          <ContentArea>{children}</ContentArea>
        </Box>
      </Box>
    </Box>
  );
};

export default MainLayout;
